<div class="dialog small">
  <div class="search-list-dialog-close" [mat-dialog-close]="false"></div>
  @if (data.icon) {
    <div class="dialog-icon">
      <svg-icon [src]="data.icon" [svgStyle]="{ width: '40px', height: '40px' }"></svg-icon>
    </div>
  }
  <h3 class="dialog-title" data-testid="error-title">{{ data.title }}</h3>
  @if (data.body) {
    <div class="dialog-body">
      <div class="dialog-subtitle" data-testid="error-subtitle">{{ data.body }}</div>
    </div>
  }

  <div class="dialog-actions single mt-5">
    <button class="btn btn-primary" data-testid="close-dialog-error" (click)="onClose($event)">
      {{ 'shared.close' | translate }}
    </button>
  </div>
</div>
